import '../../style/index.less';
import './index.less'; // style dependencies

import '../../tooltip/style';
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/rate/style/index.js
// module id = 1428
// module chunks = 0